import { library } from '@fortawesome/fontawesome-svg-core'
import { faAward } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import PreTitle from 'Root/App/PreTitle'
import Title from 'Root/App/Title'

import styles from './index.module.css'

library.add(faAward)

interface CertificateProps {
  customClass?: string
  onClick?: () => void
}

const Certificate = ({ customClass = '', onClick }: CertificateProps) => {
  return (
    <div
      className={`${styles.certificateWrapper} ${customClass}`}
      onClick={onClick}
    >
      <FontAwesomeIcon
        className={styles.certificateIcon}
        icon={['fas', 'award']}
      />
      <div>
        <PreTitle className="text-gray-500" size="XS">
          <Trans>incluso</Trans>
        </PreTitle>
        <Title size="XS">
          <Trans>Certificato di completamento</Trans>
        </Title>
      </div>
    </div>
  )
}

export default Certificate
